import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TaxEngineService {

    // 🔥 Decide tax structure based on Supply Type + State
    getTaxStructure(supplyType: string, fromState: string, toState: string): string {

        switch (supplyType) {

            case 'B2B':
            case 'B2C':
                return fromState === toState ? 'INTRA_STATE' : 'INTER_STATE';

            case 'SEZ':
                return 'ZERO_RATED';

            case 'EXPORT':
                return 'EXPORT';

            case 'DEEMED EXPORT':
                return 'DEEMED_EXPORT';

            default:
                return 'INTRA_STATE';
        }
    }

    // 🔥 Main Tax Calculation
    calculateProductTax(product: any, context: any) {

        const taxType = this.getTaxStructure(
            context.supplyType,
            context.fromState,
            context.toState
        );

        const qty = product.OrderQuantity || 0;
        const price = product.UnitPrice || 0;
        const gstRate = product.GSTRate || 0;

        const taxableValue = qty * price;

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (taxType === 'INTRA_STATE') {
            cgst = taxableValue * (gstRate / 200);
            sgst = taxableValue * (gstRate / 200);
        }

        if (taxType === 'INTER_STATE') {
            igst = taxableValue * (gstRate / 100);
        }

        if (taxType === 'EXPORT' || taxType === 'ZERO_RATED') {
            cgst = sgst = igst = 0;
        }

        return {
            taxableValue,
            cgst,
            sgst,
            igst,
            total: taxableValue + cgst + sgst + igst
        };
    }
}
